import _ from 'underscore';
import React from 'react';
import { StaticFormGroup } from '@bingads-webui-cc-react/layout';

import { ViewTaxFormPropTypes } from '../../shapes';
import { BaseViewTaxFormList, isTaxExemptionCertVerified } from '../../utils';
import { IsTaxExemptionCertVerifiedTypeKey, IsTaxExemptionCertVerifiedLabelKey } from '../../constants';

export const DefaultViewTaxForm = ({
  i18n,
  data,
  filledData,
  taxSchema,
  vatStatus,
  countryCode,
}) => (
  <div className="default-view-tax-form">
    <BaseViewTaxFormList
      i18n={i18n}
      uiObject={filledData}
      taxSchema={taxSchema}
      vatStatus={vatStatus}
      countryCode={countryCode}
    />
    {isTaxExemptionCertVerified(_.result(data, IsTaxExemptionCertVerifiedTypeKey)) && (
      <StaticFormGroup showLabel={false} id={`tax-info-${IsTaxExemptionCertVerifiedTypeKey}`}>
        {i18n.getString(IsTaxExemptionCertVerifiedLabelKey)}
      </StaticFormGroup>
    )}
  </div>
);

DefaultViewTaxForm.propTypes = ViewTaxFormPropTypes;
